import { makeAutoObservable } from 'mobx';
import {redirect} from 'shared/tools';
import {coreAuth} from 'shared/core';

class OAuthState {
  context;
  token;
  providers;

  constructor() {
    makeAutoObservable(this);
  }

  receiveProps({context = 'login', providers = ['google', 'microsoft'], token}) {
    this.context = context;
    this.token = token;
    this.providers = providers;
  }

  onConnectButtonClicked(provider) {
    return redirect(`/oauth?provider=${provider}&context=${this.context}${this.token ? `&token=${this.token}` : ''}&identifier=${coreAuth.company?.oktaIdentifier}`);
  }
}

export default OAuthState;
